import { type FC, useId } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { type ContactFormState } from '../../../contact-form'

export const DirectContactFormMessageInputField: FC<{
  formState: ContactFormState
}> = ({ formState }) => {
  const intl = useIntl()
  const messageId = useId()

  return (
    <FormControl
      error={!formState.model.validator.isPropertyValid('message')}
      onChange={(event): void => {
        formState.makeInputProps('message').onChange(event)
      }}
      required
    >
      <FormLabel htmlFor={messageId}>
        {intl.formatMessage({ id: 'MessageForm.label.message' })}
      </FormLabel>
      <Input
        id={messageId}
        multiline
        rows={4}
        slotProps={{
          input: {
            'data-qa-id': 'contact-form-message-field',
          },
        }}
      />
      {formState.model.validator.getFirstErrorFor('message') && (
        <FormHelperText data-qa-id="global-MessageForm-message-error-msg">
          {formState.model.validator.getFirstErrorFor('message')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
